const list3Points = () => {
    console.log("homepage");
    const $list3Points = $(".list-3-points");
    const $items = $list3Points.find(".item-list");
    const totalItems = $items.length;
    let currentIndex = 0;
    let autoProgressTimer = null;
    let activeItemTimers = []; // Store all setTimeout IDs để clear khi cần

    // Tạo style element để control ::after
    if (!$('#progress-bar-style').length) {
        $('head').append('<style id="progress-bar-style"></style>');
    }
    const $progressStyle = $('#progress-bar-style');

    // Tính chiều cao cho progress bar
    // Với 3 items: index 0 = 0%, index 1 = 33.33%, index 2 = 66.66%, index 3 (sau item cuối) = 100%
    const getProgressHeight = (index) => {
        if (index === 0) return '0%';
        const percentPerItem = 100 / totalItems;
        const totalPercent = index * percentPerItem;
        
        // Nếu đang ở item cuối cùng (index = totalItems - 1), 
        // progress phải chạy đến 100% (tức là index + 1)
        if (index === totalItems - 1) {
            // Progress chạy đến vị trí "ảo" sau item cuối = 100%
            return `calc(66.66% + 17px)`;
        }
        
        return `calc(${totalPercent}% + ${17 * (index / totalItems)}px)`;
    };

    // Function to activate item
    const activateItem = (index) => {
        $items.removeClass("active");
        $items.eq(index).addClass("active");
        
        // Add 'completed' class to all items before the active one
        $items.each(function(i) {
            if (i < index) {
                $(this).addClass("completed");
            } else {
                $(this).removeClass("completed");
            }
        });
    };

    // Function to update progress bar height
    const updateProgressBar = (targetIndex) => {
        const targetHeight = getProgressHeight(targetIndex);
        $progressStyle.html(`
            .homepage .list-3-points::after {
                height: ${targetHeight} !important;
            }
        `);
    };

    // Clear all timers (interval + all setTimeout)
    const clearAllTimers = () => {
        // Clear interval
        if (autoProgressTimer) {
            clearInterval(autoProgressTimer);
            autoProgressTimer = null;
        }
        
        // Clear all setTimeout
        activeItemTimers.forEach(timerId => clearTimeout(timerId));
        activeItemTimers = [];
    };

    // Auto-advance with smooth progress
    const startAutoProgress = () => {
        // Clear any existing timers
        clearAllTimers();

        // Function để chạy 1 cycle: progress bar -> active item
        const runCycle = () => {
            // BƯỚC 1: Tính index của item tiếp theo
            const nextIndex = (currentIndex + 1) % totalItems;
            
            // BƯỚC 2: Nếu đang ở item cuối (2) sẽ chuyển về item đầu (0)
            if (currentIndex === totalItems - 1 && nextIndex === 0) {
                // Progress đã full ở item cuối
                // Sau 2.9s active item 1 và RESET progress về 0 ngay lập tức
                const timerId = setTimeout(() => {
                    // Active item 1
                    activateItem(0);
                    currentIndex = 0;
                    
                    // Reset progress về 0 NGAY (no animation)
                    $progressStyle.html(`
                        .homepage .list-3-points::after {
                            height: 0 !important;
                            transition: none !important;
                        }
                    `);
                    
                    // Bật lại transition sau 50ms
                    setTimeout(() => {
                        $progressStyle.html(`
                            .homepage .list-3-points::after {
                                height: 0 !important;
                                transition: height 3s linear !important;
                            }
                        `);
                    }, 50);
                }, 2900);
                
                // Store timer ID
                activeItemTimers.push(timerId);
            } else {
                // BƯỚC 3: BẮT ĐẦU animate progress bar đến item tiếp theo TRƯỚC
                updateProgressBar(nextIndex);
                
                // BƯỚC 4: Sau khi progress bar chạy xong (3s), mới active item đó
                const timerId = setTimeout(() => {
                    activateItem(nextIndex);
                    currentIndex = nextIndex;
                }, 2900); // Chạm ngay trước khi transition kết thúc
                
                // Store timer ID
                activeItemTimers.push(timerId);
            }
        };

        // Chạy cycle đầu tiên ngay lập tức
        runCycle();
        
        // Sau đó lặp lại mỗi 3s
        autoProgressTimer = setInterval(runCycle, 3000);
    };

    // Manual click handler
    $list3Points.on("click", ".item-list", function() {
        const $item = $(this);
        const clickedIndex = $item.index();
        
        // Clear TẤT CẢ timers (interval + setTimeout) để tránh conflict
        clearAllTimers();
        
        // Update ngay lập tức
        currentIndex = clickedIndex;
        activateItem(clickedIndex);
        
        // Reset progress bar về vị trí của item được click (no animation)
        $progressStyle.html(`
            .homepage .list-3-points::after {
                height: ${getProgressHeight(clickedIndex)} !important;
                transition: none !important;
            }
        `);
        
        // Bật lại transition sau 50ms
        setTimeout(() => {
            $progressStyle.html(`
                .homepage .list-3-points::after {
                    height: ${getProgressHeight(clickedIndex)} !important;
                    transition: height 3s linear !important;
                }
            `);
            
            // Restart auto-progress timer SAU khi đã reset xong
            startAutoProgress();
        }, 50);
    });

    // Initialize: active item đầu tiên, progress bar = 0
    activateItem(0);
    updateProgressBar(0);

    // Start auto-progress
    startAutoProgress();
}

module.exports = list3Points;